// Identificador estable por dispositivo/navegador (NO secreto). Se usa para
// recordar equipos de confianza en el 2FA: el acceso real lo da Firebase Auth;
// esto solo evita re-pedir el código en un equipo ya verificado.
const KEY = 'mekafix_device_id';

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) ||
        `d_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Sin localStorage (modo privado extremo): id efímero → pedirá código cada vez.
    return `eph_${Math.random().toString(36).slice(2, 10)}`;
  }
}
